import React, { useState, useEffect } from "react";
import { Storage } from 'aws-amplify' 
import "../rnr.css";
import { onError } from "../libs/errorLib";
import { API } from 'aws-amplify';
import { myListTimeSeriess } from '../graphql/my.queries';
import ListGroup from "react-bootstrap/ListGroup";
import Spinner from 'react-bootstrap/Spinner';
import Table from 'react-bootstrap/Table';
import dayjs from "dayjs";

export default function View() {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [timeSeriess, setTimeSeriess] = useState({});

  useEffect(() => {
    // fetch async data within useEffect hook (not as separate function) otherwise big problems
    // https://blog.logrocket.com/usestate-vs-useref/
    //setIsLoading(true);
    //console.log(isLoading);

/*     const listTimeSeries = async () => {
      try {
        const apiData = await API.graphql({ query: myListTimeSeriess });
        const tsFromApi = apiData.data.listTimeSeriess.items;
        await Promise.all(tsFromApi);
        setTimeSeriess(apiData.data.listTimeSeriess.items);
        //console.log('tsFromApi len = ' + tsFromApi.length);
        //for (const [key, value] of Object.entries(tsFromApi)) {
          //console.log(`${key}: ${value.symbol}|${value.frequency}|${value.csvFile}`);
        //} 
      } catch (error) {
        onError(error);
      } 
    };
  
    const listFiles = async () => {
      try {
        setIsLoading(true);
        // get s3 file list details incl key (aka filename), lastModified date, size
        const files = await Storage.list('', { level: 'protected' });
        // create array of filenames only
        let filenames = [];
        files.forEach(item => filenames.push(item.key));
        // get signed URLS good for 15 minutes
        let signedURLs = files.map(f => Storage.get(f.key, { level: 'protected' }));
        signedURLs = await Promise.all(signedURLs);
        // create object (python dict) from the 2 arrays
        var result = {};
        filenames.forEach((key, i) => result[key] = signedURLs[i]);
        // set state
        setData(result);
        //console.table('state: ', this.state.data);
        /*console.log('object: ', result);
        console.log('filenames: ', filenames);
        console.log('signedURLs: ', signedURLs);
        console.log('fileDetails: ', fileDetails);
        console.table('state: ', this.state.data);
        for (const [key, value] of Object.entries(this.state.data)) {
          console.log(`${key}: ${value}`);
        }
        Object.entries(this.state.data).map(([key, value]) => {
          console.log(`${key}: ${value}`);
        }) 
      } catch (error) {
        onError(error);
      }
    };

    listTimeSeries();
    listFiles();
    setIsLoading(false); */

    const listTimeSeriesAndFiles = async () => {
      try {
        const apiData = await API.graphql({ query: myListTimeSeriess });
        const tsFromApi = apiData.data.listTimeSeriess.items;
        await Promise.all(tsFromApi);
        setTimeSeriess(apiData.data.listTimeSeriess.items);
        //console.log('tsFromApi len = ' + tsFromApi.length);
        //for (const [key, value] of Object.entries(tsFromApi)) {
          //console.log(`${key}: ${value.symbol}|${value.frequency}|${value.csvFile}`);
        //} 

        // get s3 file list details incl key (aka filename), lastModified date, size
        const files = await Storage.list('', { level: 'protected' });
        // create array of filenames only
        let filenames = [];
        files.forEach(item => filenames.push(item.key));
        // get signed URLS good for 15 minutes
        let signedURLs = files.map(f => Storage.get(f.key, { level: 'protected' }));
        signedURLs = await Promise.all(signedURLs);
        // create object (python dict) from the 2 arrays
        var result = {};
        filenames.forEach((key, i) => result[key] = signedURLs[i]);
        // set state
        setData(result);
        //console.table('state: ', this.state.data);
        /*console.log('object: ', result);
        console.log('filenames: ', filenames);
        console.log('signedURLs: ', signedURLs);
        console.log('fileDetails: ', fileDetails);
        console.table('state: ', this.state.data);
        for (const [key, value] of Object.entries(this.state.data)) {
          console.log(`${key}: ${value}`);
        }
        Object.entries(this.state.data).map(([key, value]) => {
          console.log(`${key}: ${value}`);
        }) */

      } catch (error) {
        onError(error);
      } finally {
        setIsLoading(false);
      }
    };
  
    listTimeSeriesAndFiles();

  }, []);
    
  return (
    <div>
      <main className="flex-shrink-0">
        <div className="container">
          <h4 className="mt-3">View Uploaded Symbol-File Mappings</h4>
          <div>
            { isLoading ? (
              <Spinner animation="border" style={{color: "#990000"}}/>
              ) : (
                <>
                <br />                  
                <Table size="sm" striped bordered hover>
                  <thead>
                    <tr>
                        <th>Symbol</th>
                        <th>Frequency</th>
                        <th>File</th>
                        <th>Updated</th>
                    </tr>
                  </thead>
                  <tbody>
                      {
                        Object.entries(timeSeriess).map(([key, value], index) => {
                          return(
                            <tr key={index.toString()}>
                              {
                                Object.entries(value).map(([key1, value1], index1) => {
                                  return(
                                    <td key={index1.toString()}>{index1 < 3 ? value1 : dayjs(value1).format('DD MMM YYYY HH:mm:ss Z')}</td>
                                  )
                                })
                              }                                
                            </tr>
                          )
                        })
                      }
                  </tbody>
                </Table>
                <br />
                <h4 className="mt-3">View Uploaded File List</h4>
                <ListGroup>
                  {
                    Object.entries(data).map(([key, value], index) => {
                      return(
                        <ListGroup.Item style={{borderStyle: 'none'}} key={index.toString()}><a className="rnr" href={value} download>{key}</a></ListGroup.Item>
                      )
                    })
                  }

                </ListGroup>
                <br /><p>Click the file name to download the data.</p>
                </>
              )
              }
          </div>
        </div>
      </main>
    </div>
  );
}

